module.exports = __webpack_public_path__ + "static/media/revenue.3c176786.svg";